<template>
  <div v-if="showBtn" style="cursor: pointer">
    <a class="routineproduct-button ripple-animation ripple-animation--black" @click="submit">{{
      btnName
    }}</a>
    <span v-if="productDatasetNew.Display_View === 'Carousel'">
      <div
        v-if="showPopUp"
        class="mctb_popup_03_ mctb-modal-mask"
        style="background-color: rgb(0 0 0 / 6%); top: 3% !important"
      >
        <div class="mctb_popup_04_ mctb-modal-wrapper">
          <div
            class="mctb_popup_05_ mctb-modal-container"
            style="box-shadow: 0 2px 8px rgb(0 0 0 / 5%)"
          >
            <div class="mctb_popup_06_ mctb-carousel-mode-header">
              <button class="mctb_popup_07_ mctb-modal-close" @click="submit">X</button>

              <div class="mctb_popup_08_ mctb-carousel-mode-header-top-header">
                {{ productDatasetNew.Routine_mctb_retailerHeader_text }}
              </div>

              <mctb-carousel>
                <mctb-slide v-for="(retailfulldata, index) in productNew.retailer" :key="index">
                  <div class="mctb_popup_09_ mctb-slider-outer">
                    <div
                      v-if="retailfulldata.retailer_logo"
                      class="mctb_popup_10_ mctb-slider-description mctb-image-alignment"
                    >
                      <img
                        class="mctb_popup_11_ mctb-button-image"
                        :src="retailfulldata.retailer_logo"
                        :alt="retailfulldata.retailer_name"
                      />
                    </div>
                    <p
                      class="mctb_popup_12_ mctb-slider-description"
                      v-html="retailfulldata.retailer_description"
                    ></p>
                    <button
                      class="mctb_popup_13_ mctb-popupcommon-buynow"
                      @click="
                        pageRedirectUrl(
                          retailfulldata.retailer_url,
                          retailfulldata.new_window,
                          retailfulldata,
                        )
                      "
                    >
                      <span class="mctb_popup_14_ mctb-button-text">
                        {{ retailfulldata.retailer_name }}</span
                      >
                    </button>
                  </div>
                </mctb-slide>
              </mctb-carousel>
            </div>
          </div>
        </div>
      </div>
    </span>
    <span v-if="productDatasetNew.Display_View === 'Default - PopupMode Only'">
      <div
        v-if="showPopUp"
        class="mctb_popup_03_ mctb-modal-mask"
        style="background-color: rgb(0 0 0 / 6%); top: 3% !important"
      >
        <div class="mctb_popup_04_ mctb-modal-wrapper">
          <div
            class="mctb_popup_05_ mctb-modal-container"
            style="box-shadow: 0 2px 8px rgb(0 0 0 / 5%)"
          >
            <div class="mctb_popup_06_ mctb-carousel-mode-header">
              <button class="mctb_popup_07_ mctb-modal-close" @click="submit">X</button>

              <div class="mctb_popup_08_ mctb-carousel-mode-header-top-header">
                {{ productDatasetNew.Routine_mctb_retailerHeader_text }}
              </div>

              <ul class="mctb-retailer-list" style="display: inline-grid !important">
                <li
                  v-for="(retailfulldata, index) in productNew.retailer"
                  :key="index"
                  style="padding: 5px !important"
                >
                  <a class="mctb_popup_09_ mctb-retailer-item">
                    <div class="mctb_popup_10_ mctb-retailer-image">
                      <img
                        class="mctb_popup_11_"
                        :src="retailfulldata.retailer_logo"
                        :alt="retailfulldata.retailer_name"
                      />
                    </div>
                    <p
                      class="mctb_popup_12_ mctb-slider-description"
                      v-html="retailfulldata.retailer_description"
                    ></p>
                    <button
                      class="mctb_popup_13_ mctb-retailer-buynow"
                      @click="
                        pageRedirectUrl(
                          retailfulldata.retailer_url,
                          retailfulldata.new_window,
                          retailfulldata,
                        )
                      "
                    >
                      <span class="mctb_popup_14_"> {{ retailfulldata.retailer_name }}</span>
                    </button>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </span>
  </div>
</template>
<script>
export default {
  name: 'routine-addtocart-popin-button',
  props: {
    showBtn: { type: Boolean, default: false },
    btnName: { type: String, default: '' },
    product: { type: [String, Object], default: () => ({}) },
    productDataset: { type: [String, Object], default: () => ({}) },
    conversionRequired: { type: Boolean, default: false },
  },
  data() {
    return {
      showPopUp: false,
      productNew: {},
      productDatasetNew: {},
    };
  },
  mounted() {
    if (this.conversionRequired) {
      this.productNew = JSON.parse(this.product);
      this.productDatasetNew = JSON.parse(this.productDataset);
    } else {
      this.productNew = this.product;
      this.productDatasetNew = this.productDataset;
    }
  },

  methods: {
    submit() {
      const product = this.productNew;
      this.showPopUp = !this.showPopUp;
      if (this.showPopUp) {
          dataLayer.push({ //eslint-disable-line
          event: 'uaevent',
          ecommerce: 'undefined',
          eventCategory: 'Ecommerce',
          eventAction: 'click to buy',
          event_name: 'buy_now',
          product_info: `${product.name.toLowerCase()}::${product.ean || 'none'}`,
          eventLabel: `${product.name.toLowerCase()}::${product.ean || 'none'}`,
        });
        const elems = document.querySelectorAll('.carousel-dot');
        Array.prototype.forEach.call(elems, (el) => {
          el.classList.add('pointerEventsNone');
        });
      } else {
        const elems = document.querySelectorAll('.carousel-dot');
        Array.prototype.forEach.call(elems, (el) => {
          el.classList.remove('pointerEventsNone');
        });
      }
    },
    pageRedirectUrl(redirectURL, newWindow, retailfulldata) {
      try {
        let dimension35 = '';
        const data = retailfulldata.product_size.split('/');
        if (data && data.length) {
          dimension35 = data[0];
        }
          dataLayer.push({ //eslint-disable-line
          event: 'addToCart',
          event_name: 'add_to_cart',
          eventCategory: 'Ecommerce',
          eventAction: `redirection::${retailfulldata.retailer_name.toLowerCase().trim()}`,
          eventLabel: `${retailfulldata.product_name.toLowerCase().trim()}::${retailfulldata.product_ean || 'none'}`,
          product_info: `${retailfulldata.product_name.toLowerCase().trim()}::${retailfulldata.product_ean || 'none'}`,
          step: 'redirection',
          store_name: `${retailfulldata.retailer_name.toLowerCase().trim()}`,
          ecommerce: {
            add: {
              products: [
                {
                  name: retailfulldata.product_name.toLowerCase().trim(),
                  id: retailfulldata.product_ean || 'none',
                  quantity: 1,
                  brand: 'KER',
                  price: retailfulldata.price || 'none',
                  category: retailfulldata.product_category.toLowerCase(),
                  dimension35: decodeURI(dimension35).trim() || 'none',
                  dimension38: retailfulldata.product_rating || 0,
                  dimension48: retailfulldata.product_ean || 'none',
                  dimension91: 'none',
                  variant: decodeURI(dimension35).trim() || 'none',
                },
              ],
            },
          },
        });
      } catch (error) {
        console.warn(error);
      }
      /* istanbul ignore next line */
      if (newWindow === true) {
        window.open(redirectURL, '_blank');
      } else {
        window.open(redirectURL, '_self');
      }
    },
  },
};
</script>
<style>
.pointerEventsNone {
  pointer-events: none !important;
}
</style>
